import {
  DataGridPro,
  GridFilterModel,
  GridFooter,
  GridHeaderFilterCellProps,
  GridPaginationModel, GridRowModel,
  GridSortModel, GridToolbarContainer
} from "@mui/x-data-grid-pro";
import React, {memo, useCallback, useEffect, useMemo, useState} from "react";
import {
  Alert,
  Chip, Divider, Grid,
  IconButton,
  Stack
} from "@mui/material";
import {datagridColors} from "../../../assets/simpleDatagridStyles";
import Box from "@mui/material/Box";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import {
  AttachFileRounded,
  FilterAltOutlined,
} from "@mui/icons-material";
import api from "../../../services/api";
import {useStateContext} from "../../../hooks/useStateContext";
import {useGridApiRef} from "@mui/x-data-grid";
import Avatar from "@mui/material/Avatar";
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import {InformationDialog} from "./InformationDialog";
import FastFilters from "./FastFilters";
import {SkeletonCard} from "../../ServiceProviderPages/components/SkeletonCard";
import {ActivityCard} from "./ActivityCard";

function computeMutation(newRow: GridRowModel, oldRow: GridRowModel) {
  return true;
}

interface Props {

}

export const Table: React.ComponentType<Props> = ({}) => {
  const [openHeaderFilters, setOpenHeaderFilters] = useState(false);
  const [value, setValue] = useState(0);
  const [loadingConfirm, setLoadingConfirm] = useState<boolean>(false);
  const [filterModelStatic, setFilterModelStatic] = useState<GridFilterModel>({items: []});
  const [sortModelStatic, setSortModelStatic] = useState<GridSortModel>([]);
  const [paginationModelStatic, setPaginationModelStatic] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });
  const {isMobile, user} = useStateContext();
  const [rows, setRows] = useState<any>([]);
  const [loading, setLoading] = useState<any>(false);
  const [openMoreInformationDialog, setOpenMoreInformationDialog] = useState<any>(false);
  const [view, setView] = useState<any>('grid');
  const apiRef = useGridApiRef();

  const fetchVisibleActivities = useCallback(async (fastFilterValue?: any) => {
    setLoading(true);

    const searchParams = new URLSearchParams({});

    if (fastFilterValue) {
      searchParams.set('type_id', fastFilterValue);
    }

    await api
      .get(`/sales-partner/activities`, searchParams)
      .then((result: any) => {
        setRows(result);
        setLoading(false);
      })
      .catch((error) => {
      });
  }, []);

  const columns = useMemo(() => {

    const columnArray: any = [];

    columnArray.push(
      {
        id: 1,
        field: 'row_number',
        headerName: '#',
        editable: false,
        type: 'text',
        width: 50,
        renderHeaderFilter: (params: GridHeaderFilterCellProps) => {
          return <></>;
        },
        renderHeader: (props: any) => {
          return (
            <IconButton
              size={'small'}
              onClick={() => {
                setOpenHeaderFilters(!openHeaderFilters);
              }}
            >
              <FilterAltOutlined
                sx={{
                  color: '#fff',
                }}
              />
            </IconButton>
          );
        },
        renderCell: (props: any) => {

          const currentPage = paginationModelStatic.page;
          const pageSize = paginationModelStatic.pageSize;

          const rowIndex = (currentPage * pageSize) + props.api.getRowIndexRelativeToVisibleRows(props.id) + 1;
          const hasAttachment = props.row?.has_attachment;
          return <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <b>{rowIndex}</b>
            {hasAttachment && (
              <IconButton size={'small'} disabled>
                <AttachFileRounded fontSize={'small'} color={'disabled'}/>
              </IconButton>
            )}
          </Stack>
        }
      },
      {
        id: 1,
        field: 'activity_image',
        headerName: 'Image',
        editable: false,
        type: 'string',
        with: 65,
        maxWidth: 65,
        renderCell: (props: any) => {
          return <Zoom><Avatar alt="Remy Sharp" src={props?.value?.link}/></Zoom>
        }
      },
      {
        id: 51,
        headerName: 'Activity',
        field: 'activity_name',
        type: 'string',
        flex: 1,
      },
      {
        id: 4,
        headerName: 'Type',
        field: 'activity_type',
        type: 'string',
        flex: 1,
        valueGetter: (params: any) => {
          const types = params.row?.activity?.activity_types || [];
          return types.map((t: any) => t.name).join(', ');
        }
      }
    );

    return columnArray;
  }, [
    rows,
    openHeaderFilters,
    paginationModelStatic,
    filterModelStatic,
    sortModelStatic
  ]);

  const CustomFooter = () => {
    return (
      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 8px',
        }}
      >
        <IconButton
          sx={{
            visibility: 'hidden'
          }}
          onClick={() => {

          }}
        >
          <AddIcon color={'primary'}/>
        </IconButton>
        <GridFooter/>
      </Stack>
    );
  };

  function CustomSortIconDesc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropDownRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  function CustomSortIconAsc(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',

        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  function CustomSortIcon(props: any) {
    return (
      <div
        style={{
          background: '#42948c',
          borderRadius: '40px',
          height: '15px',
          width: '15px',
        }}
      >
        <ArrowDropUpRoundedIcon
          color={'secondary'}
          sx={{
            width: '15px',
            height: '15px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
    );
  }

  const handleRowClick = (params: any) => {
    setOpenMoreInformationDialog(params.row);
  };

  const CustomToolbar = memo(() => {
    return (
      <GridToolbarContainer
        sx={{
          padding: '0px',
          gap: isMobile ? 0 : '4px',
          '& .MuiButton-root': {
            background: '#ededed',
            padding: '2px 4px',
            fontSize: '11px',
            '& .MuiSvgIcon-root': {
              fontSize: "1rem !important",
            },
            '&:hover': {
              background: '#e3e3e3',
            },
          },
        }}
      >

        {!isMobile && (
          <>

          </>
        )}


        <Box sx={{flexGrow: 1}}/>

      </GridToolbarContainer>
    );
  });

  useEffect(() => {
    fetchVisibleActivities();
  }, []);

  return (
    <>
      <FastFilters
        handleChangeFastFilter={(value) => {
          fetchVisibleActivities(value);
        }}
        onChangeView={(value) => {
          setView(value);
        }}
      />

      {view === 'table' ? (
        <Box sx={datagridColors('calc(100vh - 325px)')}>
          <DataGridPro
            apiRef={apiRef}
            sx={{
              maxHeight: 'calc(100% - 70px)',
            }}
            loading={loading}
            rows={rows}
            getRowClassName={(params: any) => {
              const color =
                params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd';
              return `${color}`;
            }}
            disableColumnMenu={true}
            columns={columns}
            disableRowSelectionOnClick
            columnHeaderHeight={38}
            rowHeight={38}
            pagination
            editMode={'cell'}
            slots={{
              // @ts-ignore
              columnSortedDescendingIcon: CustomSortIconDesc,
              columnSortedAscendingIcon: CustomSortIconAsc,
              columnUnsortedIcon: CustomSortIcon,
              footer: CustomFooter,
              toolbar: CustomToolbar,
              headerFilterMenu: null,
            }}
            unstable_headerFilters={openHeaderFilters}
            pageSizeOptions={[25, 50, 100]}
            columnBuffer={50}
            onFilterModelChange={(newModel) => setFilterModelStatic(newModel)}
            onSortModelChange={(newModel) => setSortModelStatic(newModel)}
            onPaginationModelChange={(newModel) => setPaginationModelStatic(newModel)}
            onRowClick={(params, event, details) => {
              handleRowClick(params);
            }}
          />
        </Box>
      ) : (
        <>
          <Box sx={{
            p: '10px'
          }}>
            <Grid container spacing={2} alignItems={'stretch'}>
              {loading ? (
                Array.from({length: 3}).map((_, index) => (
                  <Grid item xs={12} md={6} lg={4} xl={3} key={index}>
                    <SkeletonCard/>
                  </Grid>
                ))
              ) : (
                <>
                  {rows.length === 0 && (
                    <Grid item xs={12} md={12}>
                      <Alert severity="info">No rows</Alert>
                    </Grid>
                  )}

                  {rows.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      <Grid item xs={12} md={6} lg={4} xl={3}>
                        <ActivityCard
                          item={item}
                          onClick={() => {
                            setOpenMoreInformationDialog(item);
                          }}
                        />
                      </Grid>
                    </React.Fragment>
                  ))}
                </>
              )}
            </Grid>
          </Box>

        </>
      )}

      {openMoreInformationDialog && (
        <InformationDialog row={openMoreInformationDialog} onClose={() => {
          setOpenMoreInformationDialog(false)
        }}/>
      )}
    </>
  );

}